/* ============================================================================
   tne-sobre.js — IntersectionObserver para fade-in + counter animado dos stats.

   Quando elementos com .tne-fade-in entram em viewport (>20% visível):
   1. Adiciona classe .tne-fade-in--visible (CSS faz o fade).
   2. Se o elemento contém [data-tne-counter], anima de 0 até data-target
      em 1.5s usando easing cubic-out, com prefix/suffix.
   3. Faz unobserve para correr só uma vez.

   Respeita prefers-reduced-motion (counter renderiza valor final imediatamente).
   ============================================================================ */

(function () {
  'use strict';

  var DURATION_MS = 1500;
  var FADE_THRESHOLD = 0.2;

  var prefersReducedMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // Suporte: IntersectionObserver é praticamente universal.
  // Se não houver suporte, mostra tudo de imediato.
  var elements = document.querySelectorAll('.tne-fade-in');
  if (!elements.length) return;

  if (typeof IntersectionObserver === 'undefined') {
    Array.prototype.forEach.call(elements, function (el) {
      el.classList.add('tne-fade-in--visible');
      finalizeCounters(el);
    });
    return;
  }

  var observer = new IntersectionObserver(function (entries, obs) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      el.classList.add('tne-fade-in--visible');

      if (prefersReducedMotion) {
        finalizeCounters(el);
      } else {
        startCounters(el);
      }

      obs.unobserve(el);
    });
  }, { threshold: FADE_THRESHOLD });

  Array.prototype.forEach.call(elements, function (el) {
    observer.observe(el);
  });

  // ----- Counters dentro do elemento -----
  function startCounters(parent) {
    var counters = parent.querySelectorAll('[data-tne-counter]');
    Array.prototype.forEach.call(counters, animateCounter);
  }

  // Agrupa milhares com ponto à portuguesa: 1500 -> "1.500", 250 -> "250".
  // (Evita o bug de parseFloat("1.500") === 1.5 quando o número vinha já
  //  formatado com separador. Agora o data-target é um inteiro limpo.)
  function groupThousands(n) {
    return String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
  }

  // parseInt remove qualquer separador acidental (ponto/vírgula/espaço).
  function targetOf(el) {
    var raw = String(el.dataset.target || '').replace(/[^\d-]/g, '');
    var n = parseInt(raw, 10);
    return isNaN(n) ? null : n;
  }

  function finalizeCounters(parent) {
    var counters = parent.querySelectorAll('[data-tne-counter]');
    Array.prototype.forEach.call(counters, function (el) {
      var target = targetOf(el);
      if (target === null) return;
      el.textContent = (el.dataset.prefix || '') + groupThousands(target) + (el.dataset.suffix || '');
    });
  }

  function animateCounter(el) {
    var target = targetOf(el);
    if (target === null) return;

    var prefix = el.dataset.prefix || '';
    var suffix = el.dataset.suffix || '';
    var start = performance.now();

    function tick(now) {
      var elapsed = now - start;
      var progress = Math.min(elapsed / DURATION_MS, 1);
      // Ease-out cubic — começa rápido, acaba devagar.
      var eased = 1 - Math.pow(1 - progress, 3);
      var value = Math.round(target * eased);

      el.textContent = prefix + groupThousands(value) + suffix;

      if (progress < 1) {
        requestAnimationFrame(tick);
      }
    }

    requestAnimationFrame(tick);
  }
})();
